module.exports = __webpack_public_path__ + "static/media/match_envelopes_mountains.e3c6cf7a.jpg";